import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import { ThemeProvider } from "@mui/material";
import { theme } from "./styles/mui-theme";
import { LandingOrganism } from "./organisms/landing-organism";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <LandingOrganism />
    </ThemeProvider>
  </React.StrictMode>
);
